export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10906.ace172c8.jpg";